import {Box, Stack, Typography} from "@mui/material";
import {mono, c} from "../landingTokens";

const STACK = ["SIP TRUNK", "ASTERISK", "AUDIOSOCKET", "FLOW DESIGNER", "MCP TOOLS", "REST / WEBHOOKS"];

export const TrustMarquee = () => (
  <Box aria-label="OpenBrain technology stack" sx={{overflow: "hidden", borderTop: `1px solid ${c.line}`, borderBottom: `1px solid ${c.line}`, bgcolor: c.bg, py: 2.25, maskImage: "linear-gradient(90deg, transparent, #000 10%, #000 90%, transparent)"}}>
    <Stack className="landing-marquee-track" direction="row" gap={0}>
      {[0, 1, 2, 3].map((group) => (
        <Stack key={group} className="landing-marquee-group" direction="row" gap={{xs: 4, md: 7}} aria-hidden={group === 1}>
          {STACK.map((item) => <Typography key={`${group}-${item}`} sx={{fontFamily: mono, fontSize: 11, letterSpacing: ".2em", color: c.inkMuted, whiteSpace: "nowrap"}}>{item}</Typography>)}
        </Stack>
      ))}
    </Stack>
  </Box>
);
